module.exports = __webpack_public_path__ + "static/media/4.33b35a82.png";